<div class="grid ">
    <div class="col-12">
        <div class="card">
            <h4>Editar Vínculo do Usuário</h4>
            <form #form="ngForm" name="form" novalidate>
                <div class="formgroup" *ngIf="usuario">
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12 md:col-12">
                            <p-divider></p-divider>
                        </div>
                        <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                            <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="nome">Nome</label>
                            <label class="form-control">{{ usuario.nome }}</label>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="email">E-mail</label>
                            <label class="form-control">{{ usuario.email }}</label>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="cpf">CPF</label>
                            <label class="form-control">{{ usuario.cpf | cpfFormat }}</label>
                        </div>
                        <div class="field col-12 md:col-12">
                            <p-divider></p-divider>
                        </div>
                        <div class="field col-12 md:col-2">
                            <button pButton type="button" class="p-button-primary" icon="pi pi-plus" label="Adicionar"
                                (click)="abrirDialogPermissao()"></button>
                        </div>
                    </div>
                </div>
            </form>
            <h5>Permissões Adicionadas</h5>
            <div class="flex justify-content-center" *ngIf="exibirSpinnerTree">
                <p-progressSpinner></p-progressSpinner>
            </div>


            <p-treeTable #dt1 [value]="categoriasTreeTableSalvas" [columns]="colunasTreeTableSalvas"
                selectionMode="checkbox" [(selection)]="categoriasTreeTableSalvasSelecionada"
                styleClass=" p-datatable-sm" *ngIf="!exibirSpinnerTree">
                <ng-template pTemplate="caption">
                    <div class="flex justify-content-between flex-column sm:flex-row">
                        <div>
                            <button pButton type="button" class="p-button-danger" icon="pi pi-trash" pTooltip="Excluir"
                                (click)="excluir()" [disabled]="categoriasTreeTableSalvasSelecionada.length < 1">
                            </button>
                        </div>

                        <div>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText class="w-full" type="text" #filter (input)="buscar(dt1, $event)"
                                    placeholder="Buscar" />
                            </span>
                            <span class="ml-2">
                                <button pButton class="p-button-outlined" icon="pi pi-filter-slash"
                                    pTooltip="Limpar Filtros" (click)="limpar(dt1)"></button>
                            </span>
                        </div>

                    </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns">
                            <p-treeTableHeaderCheckbox></p-treeTableHeaderCheckbox>
                            {{ col.header}}
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns; let i = index">
                            <p-treeTableToggler [rowNode]="rowNode" *ngIf="i == 0"></p-treeTableToggler>
                            <p-treeTableCheckbox [value]="rowNode" *ngIf="i == 0"></p-treeTableCheckbox>
                            {{rowData[col.field]}}
                        </td>
                    </tr>
                </ng-template>
            </p-treeTable>
            <div class="p-fluid p-formgrid grid justify-content-between">
                <div class="field col-12 md:col-2">
                    <button type="submit" pButton [icon]="progressoRequisicao ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
                        [label]="progressoRequisicao ? 'Atualizando':'Atualizar'" (click)="atualizarPermissoes()"
                        class="p-button-success mt-5" [disabled]="categoriasTreeTableSalvas.length < 1"></button>
                </div>
                <div class="field col-12 md:col-2">
                    <button type="button" pButton icon="pi pi-arrow-left" label="Voltar" class="p-button-primary mt-5"
                        (click)="voltar()"></button>
                </div>
            </div>
            <p-dialog header="Adicionar Permissão" [(visible)]="exibirDialogPermissao" [modal]="true"
                [style]="{width: '50vw'}" [draggable]="false" [resizable]="false" [closable]="true">
                <div class="flex justify-content-center" *ngIf="exibirSpinnerDialog">
                    <p-progressSpinner></p-progressSpinner>
                </div>
                <p-treeTable #dt2 [value]="categoriasTreeTableDialog" [columns]="colunasTreeTableDialog"
                    selectionMode="checkbox" [(selection)]="categoriasTreeTableDialogSelecionada"
                    *ngIf="!exibirSpinnerDialog">

                    <ng-template pTemplate="caption">
                        <div class="flex justify-content-between flex-column sm:flex-row">

                            <div>
                                <p-treeTableHeaderCheckbox></p-treeTableHeaderCheckbox>
                                <span class="ml-2">Selecionar todas</span>
                            </div>
                            <div>
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input pInputText class="w-full" type="text" #filter (input)="buscar(dt2, $event)"
                                        placeholder="Buscar" />
                                </span>
                                <span class="ml-2">
                                    <button pButton class="p-button-outlined" icon="pi pi-filter-slash"
                                        pTooltip="Limpar Filtros" (click)="limpar(dt2)"></button>
                                </span>
                            </div>

                        </div>
                    </ng-template>
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th *ngFor="let col of columns">
                                {{col.header}}
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
                        <tr>
                            <td *ngFor="let col of columns; let i = index">
                                <p-treeTableToggler [rowNode]="rowNode" *ngIf="i == 0"></p-treeTableToggler>
                                <p-treeTableCheckbox [value]="rowNode" *ngIf="i == 0"></p-treeTableCheckbox>
                                {{rowData[col.field]}}
                            </td>
                        </tr>
                    </ng-template>
                </p-treeTable>

                <ng-template pTemplate="footer">
                    <button type="button" pButton icon="pi pi-check" label="Adicionar" class="p-button-success mt-2"
                        (click)="adicionarPermissao()"></button>
                </ng-template>
            </p-dialog>
        </div>
    </div>
</div>